import React from "react";
import LogItem from "./LogItem";

const Logs = ({ logs = [], isFile }) => {
  return (
    <div className={`py-3 d-flex flex-column align-items-start`}>
      {logs.length !== 0 &&
        logs
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
          .map((l, i) => <LogItem isFile={isFile} log={l} key={`l-${i}`} />)}
      <LogItem isFile={isFile} />
    </div>
  );
};

export default Logs;
